export const LogoMark = ({ className = "w-10 h-10" }) => (
  <img src="/images/logo.jpg" alt="Scratches 3D Printz logo" className={`${className} rounded-full bg-black object-cover border-2 border-[var(--ink)]`} />
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark className="w-11 h-11 sm:w-12 sm:h-12" />
    <span className="font-display font-extrabold text-lg sm:text-xl tracking-tight leading-none">
      Scratchs<span className="text-[var(--pink)]">3d</span>printz
    </span>
  </span>
);
